import React from "react";
import { STUDIO_IMAGE } from "../data/site";
import { Sparkles } from "lucide-react";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-ink py-24 md:py-32 px-5 md:px-10 lg:px-16 overflow-hidden">
      <div className="grid grid-cols-12 gap-8 lg:gap-16 items-center">
        <div className="col-span-12 md:col-span-6 relative">
          <div className="inline-flex items-center gap-2 bg-hot/10 border border-hot/30 rounded-full px-4 py-2 mb-6">
            <Sparkles size={14} className="text-hot" />
            <span className="font-body text-xs tracking-widest uppercase text-hot">Quem somos</span>
          </div>
          <h2 className="font-display font-extrabold text-5xl md:text-7xl leading-[0.95] text-cream mb-6">
            fazemos <span className="text-lime italic">carreiras</span>,
            <br />não <span className="line-through text-cream/40">ficheiros</span>.
          </h2>
          <p className="font-body text-lg text-cream/70 leading-relaxed mb-5 max-w-xl">
            Somos uma Agência Criativa. Gravamos, produzimos, filmamos, desenhamos e lançamos.
            O mesmo grupo que te põe no micro é o que empurra o teu single para o mundo.
          </p>
          <p className="font-body text-base text-cream/50 leading-relaxed max-w-xl">
            Trabalhamos com artistas emergentes, editoras independentes e marcas que precisam de som com carácter.
          </p>
        </div>
        <div className="col-span-12 md:col-span-6 relative">
          <div className="relative rotate-2 hover:rotate-0 transition-transform duration-500">
            <div className="aspect-[4/5] w-full max-w-md mx-auto rounded-3xl overflow-hidden border-2 border-lime/30">
              <img src={STUDIO_IMAGE} alt="Estúdio TAKA TAKA" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -top-4 -left-4 bg-lime text-ink font-display font-black px-4 py-2 rounded-full text-sm rotate-[-6deg]">
              ✦ Estúdio · Lisboa
            </div>
            <div className="absolute -bottom-4 -right-4 bg-hot text-cream font-hand text-2xl px-4 py-2 rounded-full rotate-[4deg]">
              vem cá ↗
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
